/* RAKNIDA · assets/rk-a11y.js (v1.2, 15 Oct 2026). Loaded from layout/theme.liquid on every page.
   Artwork cards (snippets/rk-product-card) and Trade pick tiles (a.rk-tp-pick-tile) are plain links, so
   screen readers announce them as links.
   Lists of cards are built in several ways across the site (bare cards, cards in wrapper divs, slots made
   by scripts), so the list semantics are settled here, once, wherever cards appear:
     1. a card link never carries role="listitem" (its link role wins);
     2. a role="list" whose direct children are bare cards drops the role, leaving a plain group of links;
     3. a role="list" whose direct children are wrappers holding a card (product-page rails, Trade picks)
        gives each wrapper role="listitem", so the list has real items;
     4. a wrapper marked role="listitem" outside any list (Trade pick slots in a plain grid) drops the role.
   Only lists and items that hold cards are touched. Runs at load and again, debounced, when cards are
   added later (rails, recently viewed, Quick View, Trade picks). Attribute changes do not re-trigger it. */
(function () {
  if (window.__rkA11y) return;
  window.__rkA11y = true;

  var SKIP = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, LINK: 1, NOSCRIPT: 1 };
  var CARD = 'a.rk-pc, a.rk-tp-pick-tile';
  function isCard(el) { return el.tagName === 'A' && (el.classList.contains('rk-pc') || el.classList.contains('rk-tp-pick-tile')); }
  function isItem(el) { return el.tagName === 'LI' || el.getAttribute('role') === 'listitem'; }
  function isList(el) { return !!el && (el.tagName === 'UL' || el.tagName === 'OL' || el.getAttribute('role') === 'list'); }

  function tidy() {
    var i, cards = document.querySelectorAll('a.rk-pc[role="listitem"]');
    for (i = 0; i < cards.length; i++) cards[i].removeAttribute('role');

    var lists = document.querySelectorAll('[role="list"]');
    for (i = 0; i < lists.length; i++) {
      var list = lists[i], kids = list.children, bare = false, wraps = [];
      for (var k = 0; k < kids.length; k++) {
        var c = kids[k];
        if (SKIP[c.tagName]) continue;
        if (isCard(c)) { bare = true; continue; }
        if (!isItem(c) && c.querySelector(CARD)) wraps.push(c);
      }
      if (bare) { list.removeAttribute('role'); continue; }
      for (var w = 0; w < wraps.length; w++) wraps[w].setAttribute('role', 'listitem');
    }

    var items = document.querySelectorAll('[role="listitem"]');
    for (i = 0; i < items.length; i++) {
      if (!isList(items[i].parentElement) && items[i].querySelector(CARD)) items[i].removeAttribute('role');
    }
  }

  function start() {
    tidy();
    if (!window.MutationObserver) return;
    var t = 0;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { clearTimeout(t); t = setTimeout(tidy, 120); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
